import { FC } from 'react'
import * as React from 'react'

import { FontFamilies, color } from '../../../style/variables'

interface Tier3MenuItemProps {
  href: string
  label: string
  onNavigate: () => void
}

const Tier3MenuItem: FC<Tier3MenuItemProps> = ({ href, label, onNavigate }) => {
  return (
    <>
      <style jsx>{`
        .tier2-menu-item {
          text-transform: uppercase;
          text-decoration: none;
          height: 64px;
          font-family: ${FontFamilies.barlow};
          font-size: 15px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 4.27;
          letter-spacing: 2px;
          text-align: center;
          color: ${color.textStandard};
          background-color: #fff5f5;
          width: 100%;
        }
        .tier2-menu-item:hover {
          color: ${color.brandPrimary};
        }
      `}</style>
      <a href={href} className="tier2-menu-item" onClick={onNavigate}>
        {label}
      </a>
    </>
  )
}

export default Tier3MenuItem
